import { render, staticRenderFns } from "./descriptionValue.vue?vue&type=template&id=4cab1488&scoped=true&"
import script from "./descriptionValue.vue?vue&type=script&lang=ts&"
export * from "./descriptionValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab1488",
  null
  
)

export default component.exports